import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '../../src/assets/icons/message-sent.icon.png'


const _hoisted_1 = { class: "ask-a-question-container" }
const _hoisted_2 = { class: "ask-a-question-wr" }
const _hoisted_3 = {
  key: 0,
  class: "block form default-form"
}
const _hoisted_4 = { class: "input-row" }
const _hoisted_5 = { class: "input-wr" }
const _hoisted_6 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_7 = { class: "input-row" }
const _hoisted_8 = { class: "input-wr w-100" }
const _hoisted_9 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_10 = { class: "input-row" }
const _hoisted_11 = { class: "input-wr w-100" }
const _hoisted_12 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_13 = { class: "input-wr w-100" }
const _hoisted_14 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_15 = { class: "input-row" }
const _hoisted_16 = { class: "input-wr w-100" }
const _hoisted_17 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_18 = { class: "input-wr w-100" }
const _hoisted_19 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_20 = { class: "button-wr" }
const _hoisted_21 = {
  key: 1,
  class: "block form form-spinner-wr"
}
const _hoisted_22 = {
  key: 2,
  class: "block form success-wr"
}
const _hoisted_23 = { class: "button-wr" }
const _hoisted_24 = { class: "lottrackr-icon-wr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "block header" }, [
        _createElementVNode("p", { class: "title blue" }, "Ask a question")
      ], -1)),
      (!$setup.isSubmitting && !$setup.success)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label" }, "Which project does your question relate to?", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.v$.projectTitle.$error }]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.projectTitle) = $event)),
                  type: "text"
                }, null, 2), [
                  [_vModelText, $setup.form.projectTitle]
                ]),
                ($setup.v$.projectTitle.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.v$.projectTitle.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "label" }, "Message", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  class: _normalizeClass(["input textarea-no-resize", { error: $setup.v$.message.$error }]),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.message) = $event)),
                  type: "text",
                  rows: "5",
                  cols: "50"
                }, null, 2), [
                  [_vModelText, $setup.form.message]
                ]),
                ($setup.v$.message.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.v$.message.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "label" }, "First name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.v$.firstName.$error }]),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.firstName) = $event)),
                  type: "text"
                }, null, 2), [
                  [_vModelText, $setup.form.firstName]
                ]),
                ($setup.v$.firstName.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.v$.firstName.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "label" }, "Last name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.v$.lastName.$error }]),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.lastName) = $event)),
                  type: "text"
                }, null, 2), [
                  [_vModelText, $setup.form.lastName]
                ]),
                ($setup.v$.lastName.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($setup.v$.lastName.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "label" }, "Email", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input", { error: $setup.v$.email.$error }]),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.email) = $event)),
                  type: "email"
                }, null, 2), [
                  [_vModelText, $setup.form.email]
                ]),
                ($setup.v$.email.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($setup.v$.email.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "label" }, "Phone", -1)),
                _createVNode($setup["Cleave"], {
                  class: _normalizeClass(["input", { error: $setup.v$.phone.$error }]),
                  modelValue: $setup.form.phone,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.phone) = $event)),
                  type: "text",
                  options: $setup.phoneNumberOption($setup.form.phone)
                }, null, 8, ["modelValue", "options", "class"]),
                ($setup.v$.phone.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.v$.phone.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                class: _normalizeClass(["button btn-min-width dark-blue", { small: !$setup.isDesktop }]),
                onClick: $setup.onSubmit
              }, "Submit", 2)
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.isSubmitting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("div", { class: "spinner" }, null, -1)
          ]))]))
        : _createCommentVNode("", true),
      ($setup.success)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "img-wr" }, [
              _createElementVNode("img", { src: _imports_0 })
            ], -1)),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "img-title-wr" }, [
              _createElementVNode("p", { class: "title" }, "Message sent! Our team will contact you soon.")
            ], -1)),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                class: _normalizeClass(["button btn-min-width dark-blue", { small: !$setup.isDesktop }]),
                onClick: $setup.closePage
              }, "Close page", 2)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_24, [
        _createVNode($setup["LottrackrPoweredIcon"], {
          redirectTo: '/',
          noBg: true
        })
      ])
    ])
  ]))
}